import config from "@/config/config";
import { authAdapter } from "@/core/auth/adapter";
import { toastGraphQLError } from "@/core/graphql/graphqlErrorToast";
import { authExchange } from "@urql/exchange-auth";
import { throwOnErrorExchange } from "@urql/exchange-throw-on-error";
import { Client, cacheExchange, errorExchange, fetchExchange } from "urql";

// Auth exchange powered by our auth adapter
const adapterAuthExchange = authExchange(async (utils) => {
	return {
		addAuthToOperation(operation) {
			const skipAuth = operation.context?.skipAuth;
			if (skipAuth) {
				return operation;
			}
			const token = authAdapter.getToken();
			if (!token) return operation;
			return utils.appendHeaders(operation, {
				Authorization: `Bearer ${token}`,
			});
		},
		didAuthError(error) {
			return error.response?.status === 401;
		},
		async refreshAuth() {
			await authAdapter.refresh();
		},
	};
});

export const urqlClient = new Client({
	url: config.BACKEND_ENDPOINT,
	suspense: true,
	exchanges: [
		cacheExchange,
		adapterAuthExchange,
		throwOnErrorExchange(),
		errorExchange({ onError: toastGraphQLError }),
		fetchExchange,
	],
});
